<ejs-dialog [visible]="visible" [header]="title" [width]="dialogWidth" [isModal]="true" [showCloseIcon]="true"
    [closeOnEscape]="true" [cssClass]="dialogCssClass" (open)="onOpen()" (close)="onClose()">
    <ng-template #content>
        <div [class]="contentCssClass">
            <div class="confirmation-icon-shell" aria-hidden="true">
                <div class="confirmation-icon-ring">
                    <div class="confirmation-icon">
                        <i [class]="iconClass"></i>
                    </div>
                </div>
            </div>

            <div class="confirmation-body">
                <div #messageElement class="confirmation-message">
                    {{ message }}
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #footerTemplate>
        <div class="confirmation-footer" [class.is-single-action]="!isYesNoMode">
            <button *ngIf="isYesNoMode" ejs-button type="button" cssClass="e-outline" (click)="onCancel()">
                {{ cancelButtonText }}
            </button>

            <button ejs-button type="button" [cssClass]="confirmButtonCssClass" (click)="onConfirm()">
                {{ confirmButtonText }}
            </button>
        </div>
    </ng-template>
</ejs-dialog>